class MobileMenu {
  constructor() {
    this.initToggle();
    this.handleDropdown();
  }

  initToggle() {
    document.querySelector('.page-header__toggler').addEventListener('click', () => {
      document.querySelector('body').classList.toggle('is-menu-open');
    });

    document.querySelector('.form-search--mobile__button-close').addEventListener('click', () => {
      document.querySelector('.form-search--mobile').classList.remove('d-flex');
    });

    document.querySelector('.page-header__search--cta').addEventListener('click', () => {
      document.querySelector('.form-search--mobile').classList.add('d-flex');
    });
  }

  handleDropdown() {
    const mobileMenuLinks = document.querySelectorAll('.mobile-menu .nav-link');

    mobileMenuLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        link.classList.toggle('show');
        link.nextElementSibling.classList.toggle('show');
      });
    });
  }
}

export default MobileMenu;



// WEBPACK FOOTER //
// ./scripts/components/mobileMenu.js